const SENSITIVE_KEY_PATTERN =
  /(token|secret|password|authorization|cookie|session|api[-_]?key|jwt|email|phone|address|lat|lng|longitude|latitude)/i;

const MAX_STRING_LENGTH = 240;
const MAX_DEPTH = 4;
const MAX_ARRAY_LENGTH = 20;

function truncate(value: string): string {
  if (value.length <= MAX_STRING_LENGTH) {
    return value;
  }
  return `${value.slice(0, MAX_STRING_LENGTH)}…`;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

function sanitizeValue(value: unknown, depth: number): unknown {
  if (depth > MAX_DEPTH) {
    return '[truncated_depth]';
  }
  if (typeof value === 'string') {
    return truncate(value);
  }
  if (
    typeof value === 'number' ||
    typeof value === 'boolean' ||
    value === null ||
    value === undefined
  ) {
    return value;
  }
  if (Array.isArray(value)) {
    return value.slice(0, MAX_ARRAY_LENGTH).map((item) => sanitizeValue(item, depth + 1));
  }
  if (isRecord(value)) {
    return sanitizeRecord(value, depth + 1);
  }
  return String(value);
}

export function sanitizeRecord(
  record: Record<string, unknown>,
  depth: number = 0
): Record<string, unknown> {
  const output: Record<string, unknown> = {};
  Object.entries(record).forEach(([key, value]) => {
    if (SENSITIVE_KEY_PATTERN.test(key)) {
      output[key] = '[redacted]';
      return;
    }
    output[key] = sanitizeValue(value, depth);
  });
  return output;
}

export function sanitizeMessage(input: string): string {
  return truncate(input);
}
